// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideThumbsDown as RawLucideThumbsDown } from "lucide-react";
export const LucideThumbsDown = /* @__PURE__ */ createIcon(RawLucideThumbsDown, "LucideThumbsDown", 2);
